module.exports = __webpack_public_path__ + "static/media/colicoli01.ed6d064a.webp";